<template>
  <Registro v-if="alerta.ordem == 101" paddingSemCheckBox>

      <Notificacao v-if="alerta.alerta" :tipo="'alerta'" :texto="alerta.alerta" />
      <!-- <Cabecalho class="alerta-zfm-alc" v-if="alerta.alerta" :titulo="'ALERTA'" />
      <div v-if="alerta.alerta" class="separador" />
      <Cabecalho v-if="alerta.alerta" :titulo="alerta.alerta" /> -->

    <div v-else>
      <div class="alerta-zfm-box" v-if="alerta.alerta_zfm">
        <div class="alerta-zfm">
          <font-awesome-icon icon="exclamation-triangle" />
          <p class="alerta-zfm-titulo">INAPLICABILIDADE DA ZFM</p>
        </div>
      </div>

      <div v-if="alerta.alerta_zfm" class="separador" />
      <Cabecalho v-if="alerta.alerta_zfm" :titulo="alerta.alerta_zfm" />
      <div v-if="alerta.alerta_zfm" class="separador" />

      <div class="alerta-zfm-box"   v-if="alerta.alerta_alc">
        <div class="alerta-zfm">
          <font-awesome-icon icon="exclamation-triangle" />
          <p class="alerta-zfm-titulo">INAPLICABILIDADE DA ALC</p>
        </div>
      </div>


      <div v-if="alerta.alerta_alc" class="separador" />
      <Cabecalho v-if="alerta.alerta_alc" :titulo="alerta.alerta_alc" />
      <div v-if="alerta.alerta_alc" class="separador" />
      <div class="alerta-zfm-box"    v-if="alerta.alerta_ao">
        <div class="alerta-zfm">
          <font-awesome-icon icon="exclamation-triangle" />
          <p class="alerta-zfm-titulo">INAPLICABILIDADE DA AO</p>
        </div>
      </div>

      <div v-if="alerta.alerta_ao" class="separador" />
      <Cabecalho v-if="alerta.alerta_ao" :titulo="alerta.alerta_ao" />
      <div v-if="alerta.alerta_ao" class="separador" />

      <Ncm :ncm="alerta.ncm" />
      <div v-if="alerta.ncm" class="separador" />

      <Descricao :titulo="'Descrição'" :descricao="alerta.descricao" />
      <div v-if="alerta.descricao" class="separador" />

      <BaseLegal :base_legal="alerta.base_legal" />
    </div>
  </Registro>
  <Registro v-else-if="alerta.alerta_zfm || alerta.alerta_alc" paddingSemCheckBox>
    <div class="registro-alerta">

      <div class="alerta-zfm-box" v-if="alerta.alerta_zfm">
        <div class="alerta-zfm">
          <font-awesome-icon icon="exclamation-triangle" />
          <p class="alerta-zfm-titulo">INAPLICABILIDADE DA ZFM</p>
        </div>
      </div>
      <div v-if="alerta.alerta_zfm" class="separador" />
      <Cabecalho v-if="alerta.alerta_zfm" :titulo="alerta.alerta_zfm" />
      <div v-if="alerta.alerta_zfm && alerta.alerta_alc" class="separador" />

      <div class="alerta-zfm-box"   v-if="alerta.alerta_alc">
        <div class="alerta-zfm">
          <font-awesome-icon icon="exclamation-triangle" />
          <p class="alerta-zfm-titulo">INAPLICABILIDADE DA ALC</p>
        </div>
      </div>

      <div v-if="alerta.alerta_alc" class="separador" />
      <Cabecalho v-if="alerta.alerta_alc" :titulo="alerta.alerta_alc" />
      <div v-if="alerta.alerta_alc" class="separador" />

      <Ncm :ncm="alerta.ncm_uf" />
      <div v-if="alerta.ncm_uf" class="separador" />

      <Descricao :titulo="'Descrição'" :descricao="alerta.descricao_uf" />
      <div v-if="alerta.descricao_uf" class="separador" />

      <BaseLegal :base_legal="alerta.base_legal_uf" />
    </div>
  </Registro>
</template>

<script>
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Registro from "@/components/Registro/Registro.vue";

export default {
  name: "QuadroAlertaZfm",

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    Notificacao,
    Registro,
    Ncm
  },

  props: {
    alerta: Object
  }
};
</script>

<style lang="scss" scoped>
.alerta-zfm {
  display: flex;
  align-items: center;
}
.alerta-zfm-titulo {
  margin-left: 10px;
  color: #bc2c2c;
  font-size: 1rem;
  margin-bottom: 0;
  font-weight: 400;
}
.alerta-zfm-box {
  display: inline-block;
  border-radius: 3px;
  box-shadow: 3px 3px rgba(14, 17, 19, 0.089);
  align-items: center;
  background-color: var(--branco);
  color: #bc2c2c;
  padding: 5px;
}
.alerta-zfm-alc {
  color: orange;
}
@media only print {
  .alerta-zfm-alc {
    color: var(--preto);
  }
}
</style>
